<script lang="ts">
    import { Html5Qrcode } from 'html5-qrcode'
    import { onMount } from 'svelte'
    import IconifyIcon from '@iconify/svelte'
    import qrcodeIcon from '@iconify/icons-fa-solid/qrcode'
    import closeIcon from '@iconify/icons-fa-solid/times'

    export let address
    let visible = false
    let scanning = false
    let html5Qrcode

    enum Html5QrcodeSupportedFormats {
        QR_CODE = 0
    }

    onMount(init)

    function init() {
        html5Qrcode = new Html5Qrcode('qr-code-reader')
    }

    function start() {
        visible = true
        html5Qrcode.start(
            { facingMode: 'environment' },
            {
                fps: 10,
                qrbox: { width: 250, height: 250 },
                formatsToSupport: [Html5QrcodeSupportedFormats.QR_CODE],
                videoConstraints: {
                    facingMode: 'environment',
                    aspectRatio: 1.0
                }
            },
            onScanSuccess,
            onScanFailure
        )
        scanning = true
    }

    async function stop() {
        visible = false
        await html5Qrcode.stop()
        scanning = false
    }

    function onScanSuccess(decodedText, decodedResult) {
        address = decodedText
        visible = false
        html5Qrcode.stop()
        scanning = false
    }

    function onScanFailure(error) {
        // console.warn(`Code scan error = ${error}`)
    }
</script>

{#if visible}
    <button class="scanner-btn" on:click={stop}>
        <IconifyIcon icon={closeIcon}/>
    </button>
{:else}
    <button class="scanner-btn" on:click={start}>
        <IconifyIcon icon={qrcodeIcon}/>
    </button>
{/if}

<main class:d-none={!visible}>
    <div class="allow-text">Allow access to the camera <br>on this device</div>
    <reader id="qr-code-reader"></reader>
</main>

<style>
    .scanner-btn {
        position: absolute;
        right: 0;
        top: 0;
        background: #384056;
        color: #cad5e0;
        border: 1px solid #cad5e0;
        width: 36px;
        height: 36px;
        border-radius: 6px;
        margin: 7px;
        display: none;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        padding: 0;
        transition: .25s;
    }

    main {
        gap: 20px;
        width: 100%;
        min-height: 500px;
        background-color: #384056;
        border: 1px solid #CAD5E0;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #cad5e0;
        font-size: 16px;
        overflow: hidden;
        margin: 18px 0;
    }

    .allow-text {
        position: absolute;
        text-align: center;
        padding: 15px;
    }

    reader {
        width: 100%;
        height: 100%;
    }

    @media(max-width: 991px) {
        .scanner-btn {
            display: flex;
        }
    }

    @media(max-width: 767px) {
        main {
            height: calc(100vw - 30px);
            max-height: 500px;
            min-height: inherit;
        }

        .scanner-btn {
            width: 32px;
            height: 32px;
            font-size: 16px;
        }
    }
</style>
